import { useUpdateCollectionPrivacyMutation } from '@frameio/graphql-client/generated';

type UpdateCollectionPrivacyArgs = {
  collectionId: string;
  isPrivate: boolean;
};

type UpdateCollectionReturn = {
  updateCollectionPrivacy: (args: UpdateCollectionPrivacyArgs) => void;
};

export function useUpdateCollectionPrivacy(): UpdateCollectionReturn {
  const [updateCollectionPrivacy] = useUpdateCollectionPrivacyMutation();

  const handleUpdateCollectionPrivacy = async ({
    collectionId,
    isPrivate,
  }: UpdateCollectionPrivacyArgs) => {
    await updateCollectionPrivacy({
      variables: {
        collectionId,
        isPrivate,
      },
      optimisticResponse: {
        __typename: 'Mutation',
        updateCollection: {
          __typename: 'UpdateCollectionPayload',
          collection: {
            id: collectionId,
            private: isPrivate,
            __typename: 'Collection',
          },
        },
      },
    });
  };

  return {
    updateCollectionPrivacy: handleUpdateCollectionPrivacy,
  };
}
